module.exports = __webpack_public_path__ + "static/media/unilever.c1cf7966.svg";